import { render, staticRenderFns } from "./ProfitRecommendation.vue?vue&type=template&id=0fd09c56&scoped=true"
import script from "./ProfitRecommendation.vue?vue&type=script&lang=js"
export * from "./ProfitRecommendation.vue?vue&type=script&lang=js"
import style0 from "./ProfitRecommendation.vue?vue&type=style&index=0&id=0fd09c56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd09c56",
  null
  
)

export default component.exports
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QTable,QTr,QTh,QTd});
